import { useMemo } from 'react';
import { prop } from 'ramda';
import { useFormatter } from 'js/hooks/useFormatter';
import { useGamesConfiguration } from 'js/hooks/games';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';

import { WINNER_INFO } from '../constants';
import { useDynamicReducerSelector } from '../store';

export const useTopWinners = () => {
    const formatter = useFormatter();
    const { gamesConfig } = useGamesConfiguration();
    const { winnersInfo = WINNER_INFO.INITIALS } = useComponentConfig();
    const topWinners = useDynamicReducerSelector(prop('topWinners'));

    return useMemo(() => {
        if (!gamesConfig?.games) {
            return [];
        }

        return (topWinners || [])
            .filter(({ gameType }) => gamesConfig.games[gameType])
            .map(winner => {
                const {
                    id, gameType, nickname, lastNameInitial, firstNameInitial,
                    winAmount: { amount, currencyCode },
                    jackpotWinAmount: { amount: jackpotAmount, currencyCode: jackpotCurrencyCode }
                } = winner;
                const initials = `${firstNameInitial}. ${lastNameInitial}.`;
                const player = winnersInfo === WINNER_INFO.INITIALS
                    ? initials
                    : nickname || initials;
                const winAmount = Number(amount) === 0
                    ? formatter.formatCurrency(jackpotAmount, { jackpotCurrencyCode })
                    : formatter.formatCurrency(amount, { currencyCode });

                return {
                    id,
                    player,
                    winAmount,
                    gameCode: gameType,
                    gameName: gamesConfig.games[gameType].name
                };
            });
    }, [winnersInfo, topWinners, formatter, gamesConfig]);
};
